import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQuery } from 'shared/api/rtk-query';

export const mediaApi = createApi({
  reducerPath: 'media-api',
  baseQuery: createBaseQuery(),
  tagTypes: ['media-commerce', 'MediaList', 'MediaCities'],
  endpoints: () => ({}),
});
